"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[64174],{

/***/ 652321:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ HeadphoneOutlined; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(404334);


const HeadphoneOutlined = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M9.10969 2C5.82201 2 3.15654 4.66548 3.15654 7.95315V10.6102C2.43563 11.4495 2 12.541 2 13.7342C2 15.4741 2.92607 16.9975 4.31223 17.8384V18.7061C4.31223 20.7172 5.9417 22.3467 7.95286 22.3467H13.7341C14.1484 22.3467 14.4841 22.0109 14.4841 21.5967C14.4841 21.1825 14.1484 20.8467 13.7341 20.8467H7.95286C6.77012 20.8467 5.81223 19.8888 5.81223 18.7061V18.43C6.13004 18.4963 6.45939 18.5311 6.7969 18.5311H7.95315C8.68666 18.5311 9.28128 17.9365 9.28128 17.203V10.2655C9.28128 9.53197 8.68666 8.93735 7.95315 8.93735H6.7969C6.02771 8.93735 5.30084 9.11835 4.65654 9.44009V7.95315C4.65654 5.4939 6.65044 3.5 9.10969 3.5H14.891C17.3502 3.5 19.3441 5.4939 19.3441 7.95315V9.44007C18.6998 9.11835 17.973 8.93735 17.2038 8.93735H16.0475C15.314 8.93735 14.7194 9.53197 14.7194 10.2655V17.203C14.7194 17.9365 15.314 18.5311 16.0475 18.5311H17.2038C19.8532 18.5311 22.0007 16.3837 22.0007 13.7342C22.0007 12.5409 21.5651 11.4495 20.8441 10.6102V7.95315C20.8441 4.66548 18.1786 2 14.891 2H9.10969ZM3.5 13.7342C3.5 11.9133 4.9759 10.4374 6.7969 10.4374H7.78128V17.0311H6.7969C4.9759 17.0311 3.5 15.5552 3.5 13.7342ZM16.2194 17.0311H17.2038C19.0248 17.0311 20.5007 15.5552 20.5007 13.7342C20.5007 11.9133 19.0248 10.4374 17.2038 10.4374H16.2194V17.0311Z",
          fill: "#82869E"
        }
      }
    ]
  })(props);
};




/***/ }),

/***/ 64174:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Layout": function() { return /* binding */ Layout; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(561261);
/* harmony import */ var i18n__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(634655);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(891987);
/* harmony import */ var tenants_template_desktop_module_Layout__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(254607);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(855271);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(46610);
/* harmony import */ var contexts__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(684443);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(652321);
/* harmony import */ var _teko_teko_ecommerce__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(652966);
/* harmony import */ var components_desktop_organisms__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(211888);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        "\n  display: flex;\n  height: 100%;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 2rem 4rem;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _taggedTemplateLiteral([
        "\n  flex: 1;\n  display: flex;\n  justify-content: space-between;\n  align-items: start;\n  padding: 2rem 4rem 1rem 0;\n  gap: 0.75rem;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = _taggedTemplateLiteral([
        "\n  text-transform: uppercase;\n  font-weight: 500;\n  font-size: 1rem;\n  font-size: 1rem;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  margin: 0.5rem 0;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = _taggedTemplateLiteral([
        "\n  color: #333;\n  text-decoration: none;\n  white-space: pre;\n\n  &:hover {\n    color: #eb1f3b;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    const data = _taggedTemplateLiteral([
        "\n  margin-right: 8px;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    const data = _taggedTemplateLiteral([
        "\n  gap: 0.75rem;\n  padding: 2rem 3rem 4rem;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    const data = _taggedTemplateLiteral([
        "\n  width: 320px;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    const data = _taggedTemplateLiteral([
        "\n  flex: 1;\n  display: flex;\n  gap: 16px;\n  justify-content: space-around;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    const data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  align-items: center;\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}









const rightMenu = [
    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_teko_ecommerce__WEBPACK_IMPORTED_MODULE_2__/* .TopbarButton */ .S, {
        href: "tel:19007059",
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_3__/* .HeadphoneOutlined */ .g, {
            color: "white",
            size: 18
        }),
        tracking: {
            isTrackContent: true,
            regionName: "taskbar",
            contentName: "hotlineSupportURL"
        },
        children: "1900 7059"
    }, 1),
    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_desktop_organisms__WEBPACK_IMPORTED_MODULE_4__/* .LanguageSelector */ .$, {}, 2), 
];
const FooterWrapper = _teko_ui__WEBPACK_IMPORTED_MODULE_5__/* .styled.div */ .z.div((param)=>{
    let { backgroundColor  } = param;
    return "\n    display: flex;\n    padding-top: 24px;\n    background-color: ".concat(backgroundColor || "#fff", ";\n  ");
});
const Brand = _teko_ui__WEBPACK_IMPORTED_MODULE_5__/* .styled.div */ .z.div(_templateObject());
const LogoDesc = _teko_ui__WEBPACK_IMPORTED_MODULE_5__/* .styled.div */ .z.div((param)=>{
    let { theme  } = param;
    return "\n  text-transform: uppercase;\n  color: ".concat(theme === null || theme === void 0 ? void 0 : theme.brand.primary, ";\n  font-weight: 500;\n  margin-top: 1rem;\n  font-size: 1.25rem;\n");
});
const FooterContent = _teko_ui__WEBPACK_IMPORTED_MODULE_5__/* .styled.div */ .z.div(_templateObject1());
const Title = _teko_ui__WEBPACK_IMPORTED_MODULE_5__/* .styled.div */ .z.div(_templateObject2());
const Info = _teko_ui__WEBPACK_IMPORTED_MODULE_5__/* .styled.div */ .z.div(_templateObject3());
const StyledLink = _teko_ui__WEBPACK_IMPORTED_MODULE_5__/* .styled.a */ .z.a(_templateObject4());
const StyledIcon = (0,_teko_ui__WEBPACK_IMPORTED_MODULE_5__/* .styled */ .z)(_teko_ui__WEBPACK_IMPORTED_MODULE_6__/* .SvgIcon */ .l)(_templateObject5());
const FooterInfoWrapper = (0,_teko_ui__WEBPACK_IMPORTED_MODULE_5__/* .styled */ .z)(FooterWrapper)(_templateObject6());
const CompanyInfo = _teko_ui__WEBPACK_IMPORTED_MODULE_5__/* .styled.div */ .z.div(_templateObject7());
const Address = _teko_ui__WEBPACK_IMPORTED_MODULE_5__/* .styled.div */ .z.div(_templateObject8());
const Verified = _teko_ui__WEBPACK_IMPORTED_MODULE_5__/* .styled.div */ .z.div(_templateObject9());
const Layout = (_param)=>{
    var { children  } = _param, props = _objectWithoutProperties(_param, [
        "children"
    ]);
    const { theme  } = (0,contexts__WEBPACK_IMPORTED_MODULE_7__/* .useGlobalData */ .U5)();
    const infos = [
        {
            label: (0,i18n__WEBPACK_IMPORTED_MODULE_8__.t)("Giới thiệu về Umbala"),
            link: "/gioi-thieu-umbala"
        },
        {
            label: (0,i18n__WEBPACK_IMPORTED_MODULE_8__.t)("Quy chế hoạt động"),
            link: "/quy-che-hoat-dong"
        },
        {
            label: (0,i18n__WEBPACK_IMPORTED_MODULE_8__.t)("Điều khoản giao dịch"),
            link: "/dieu-khoan-giao-dich"
        },
        {
            label: (0,i18n__WEBPACK_IMPORTED_MODULE_8__.t)("Th\xf4ng b\xe1o từ Umbala"),
            link: "/thong-bao-tu-umbala"
        },
        {
            label: (0,i18n__WEBPACK_IMPORTED_MODULE_8__.t)("C\xe2u hỏi thường gặp"),
            link: "/cau-hoi-thuong-gap"
        }, 
    ];
    const policies = [
        {
            label: (0,i18n__WEBPACK_IMPORTED_MODULE_8__.t)("Ch\xednh s\xe1ch bảo mật th\xf4ng tin"),
            link: "/chinh-sach-bao-mat-thong-tin"
        },
        {
            label: (0,i18n__WEBPACK_IMPORTED_MODULE_8__.t)("Ch\xednh s\xe1ch h\xe0ng h\xf3a"),
            link: "/chinh-sach-hang-hoa"
        },
        {
            label: (0,i18n__WEBPACK_IMPORTED_MODULE_8__.t)("Ch\xednh s\xe1ch th\xe0nh vi\xean"),
            link: "/chinh-sach-thanh-vien"
        },
        {
            label: (0,i18n__WEBPACK_IMPORTED_MODULE_8__.t)("Ch\xednh s\xe1ch thanh to\xe1n"),
            link: "/chinh-sach-thanh-toan"
        },
        {
            label: (0,i18n__WEBPACK_IMPORTED_MODULE_8__.t)("Ch\xednh s\xe1ch đổi trả"),
            link: "/chinh-sach-doi-tra"
        },
        {
            label: (0,i18n__WEBPACK_IMPORTED_MODULE_8__.t)("Ch\xednh s\xe1ch bảo h\xe0nh"),
            link: "/chinh-sach-bao-hanh"
        }, 
    ];
    const guides = [
        {
            label: (0,i18n__WEBPACK_IMPORTED_MODULE_8__.t)("Hướng dẫn mua h\xe0ng"),
            link: "/huong-dan-mua-hang"
        },
        {
            label: (0,i18n__WEBPACK_IMPORTED_MODULE_8__.t)("Hướng dẫn sử dụng"),
            link: "/huong-dan-su-dung"
        }, 
    ];
    const follows = [
        {
            icon: "logo-facebook",
            label: (0,i18n__WEBPACK_IMPORTED_MODULE_8__.t)("UMBALA VIỆT NAM"),
            link: "https://www.facebook.com/UmbalaVietNam"
        },
        {
            icon: "logo-youtube",
            label: (0,i18n__WEBPACK_IMPORTED_MODULE_8__.t)("UMBALA VIỆT NAM"),
            link: "https://www.youtube.com/channel/UCTLe3hdNCmF_tjRv060LAqw"
        },
        {
            icon: "logo-tiktok",
            label: (0,i18n__WEBPACK_IMPORTED_MODULE_8__.t)("UMBALA VIỆT NAM"),
            link: "https://www.tiktok.com/@umbalavietnam"
        },
        {
            icon: "logo-instagram",
            label: (0,i18n__WEBPACK_IMPORTED_MODULE_8__.t)("UMBALA VIỆT NAM"),
            link: "https://www.instagram.com/umbala_vn"
        }, 
    ];
    const Footer = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(FooterWrapper, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Brand, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                src: "https://shopfront-cdn.tekoapis.com/static/umbala/logo_lite.png",
                                alt: "Umbala Vietnam",
                                width: 96,
                                height: 96
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(LogoDesc, {
                                children: (0,i18n__WEBPACK_IMPORTED_MODULE_8__.t)("Đặc Quyền Mua Sỉ")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(FooterContent, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Title, {
                                        children: (0,i18n__WEBPACK_IMPORTED_MODULE_8__.t)("Li\xean hệ")
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Info, {
                                        children: (0,i18n__WEBPACK_IMPORTED_MODULE_8__.t)("Hỗ trợ từ 8:00 - 22:00")
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Info, {
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledLink, {
                                            href: "tel:19007059",
                                            children: (0,i18n__WEBPACK_IMPORTED_MODULE_8__.t)("Tổng đ\xe0i: 1900 7059")
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Info, {
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledLink, {
                                            href: "tel:02871097059",
                                            children: "Hotline: (028) 7109 7059"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Info, {
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(StyledLink, {
                                            href: "tel:0936206602",
                                            children: [
                                                "                ",
                                                "0936 206 602"
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledLink, {
                                        href: "mailto:info@umbala.vn",
                                        children: "Email: info@umbala.vn"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Title, {
                                        children: (0,i18n__WEBPACK_IMPORTED_MODULE_8__.t)("Giới thiệu")
                                    }),
                                    infos.map((info)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Info, {
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledLink, {
                                                href: info.link,
                                                target: "_blank",
                                                rel: "noopener noreferrer",
                                                children: info.label
                                            })
                                        }, info.link))
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Title, {
                                        children: (0,i18n__WEBPACK_IMPORTED_MODULE_8__.t)("Ch\xednh s\xe1ch")
                                    }),
                                    policies.map((info)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Info, {
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledLink, {
                                                href: info.link,
                                                target: "_blank",
                                                rel: "noopener noreferrer",
                                                children: info.label
                                            })
                                        }, info.link))
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Title, {
                                        children: (0,i18n__WEBPACK_IMPORTED_MODULE_8__.t)("Hướng dẫn")
                                    }),
                                    guides.map((info)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Info, {
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledLink, {
                                                href: info.link,
                                                target: "_blank",
                                                rel: "noopener noreferrer",
                                                children: info.label
                                            })
                                        }, info.link))
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Title, {
                                        children: (0,i18n__WEBPACK_IMPORTED_MODULE_8__.t)("Theo d\xf5i ch\xfang t\xf4i")
                                    }),
                                    follows.map((info)=>{
                                        var ref;
                                        /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Info, {
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledIcon, {
                                                    name: info.icon,
                                                    size: 16,
                                                    color: theme === null || theme === void 0 ? void 0 : (ref = theme.brand) === null || ref === void 0 ? void 0 : ref.primary
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledLink, {
                                                    href: info.link,
                                                    target: "_blank",
                                                    rel: "noopener noreferrer",
                                                    children: info.label
                                                })
                                            ]
                                        }, info.link);
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(FooterInfoWrapper, {
                backgroundColor: "#e9edf2",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(CompanyInfo, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Title, {
                                children: (0,i18n__WEBPACK_IMPORTED_MODULE_8__.t)("C\xf4ng ty cổ phần umbala việt nam")
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Info, {
                                children: (0,i18n__WEBPACK_IMPORTED_MODULE_8__.t)("M\xe3 số thuế: 0314329846")
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Info, {
                                children: (0,i18n__WEBPACK_IMPORTED_MODULE_8__.t)("Địa chỉ: 292/15 C\xe1ch Mạng Th\xe1ng T\xe1m")
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Info, {
                                children: (0,i18n__WEBPACK_IMPORTED_MODULE_8__.t)("Phường 10, Quận 3, Th\xe0nh phố Hồ Ch\xed Minh")
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Info, {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledLink, {
                                    href: "mailto:umbala@umbala.vn",
                                    children: "Email: umbala@umbala.vn"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Info, {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledLink, {
                                    href: "/",
                                    children: "Website: umbala.vn"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Info, {
                                children: (0,i18n__WEBPACK_IMPORTED_MODULE_8__.t)("App: Umbala Việt Nam")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Address, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Title, {
                                        children: (0,i18n__WEBPACK_IMPORTED_MODULE_8__.t)("Hồ ch\xed minh")
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        children: [
                                            (0,i18n__WEBPACK_IMPORTED_MODULE_8__.t)("umbala.desktop._module.Layout.0"),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                            (0,i18n__WEBPACK_IMPORTED_MODULE_8__.t)("Th\xe0nh phố Hồ Ch\xed Minh")
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Title, {
                                        children: (0,i18n__WEBPACK_IMPORTED_MODULE_8__.t)("Đ\xe0 Nẵng")
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        children: [
                                            (0,i18n__WEBPACK_IMPORTED_MODULE_8__.t)("Tầng 2. Số 14-16 Nguyễn Văn Linh Phường Nam Dương"),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                            (0,i18n__WEBPACK_IMPORTED_MODULE_8__.t)("Quận Hải Ch\xe2u, TP. Đ\xe0 Nẵng")
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Verified, {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Title, {
                                                children: (0,i18n__WEBPACK_IMPORTED_MODULE_8__.t)("H\xe0 nội")
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                children: [
                                                    (0,i18n__WEBPACK_IMPORTED_MODULE_8__.t)("Tầng 6. Số 01 Th\xe1i H\xe0, Phường Trung Liệt"),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                                    (0,i18n__WEBPACK_IMPORTED_MODULE_8__.t)("Quận Đống Đa, H\xe0 Nội")
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledLink, {
                                        href: "http://online.gov.vn/Home/WebDetails/33227",
                                        target: "_blank",
                                        rel: "noopener noreferrer",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                            src: "https://phongvu.vn/media/wysiwyg/phongvu/phongvu_v3/da-dang-ky.png",
                                            alt: "Verified Logo",
                                            width: 200
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(tenants_template_desktop_module_Layout__WEBPACK_IMPORTED_MODULE_9__.Layout, _objectSpreadProps(_objectSpread({}, props), {
        rightMenu: rightMenu,
        footer: Footer,
        children: children
    }));
};


/***/ })

}]);